// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__e541c9ba31af81b25f31{/*!*/}.AuthorHeader-cls2__de4e2e9df7c1f1853bd0{position:relative}.AuthorHeader-cls2__de4e2e9df7c1f1853bd0:not(:first-child){margin-left:-9px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__e541c9ba31af81b25f31",
	"cls2": "AuthorHeader-cls2__de4e2e9df7c1f1853bd0 AuthorHeader-cls1__e541c9ba31af81b25f31"
};
export default ___CSS_LOADER_EXPORT___;
